export const PENDING_CALL_OPENED = 'PENDING_CALL_OPENED'
export const PENDING_CALL_CLOSED = 'PENDING_CALL_CLOSED'
